import React from 'react'

import Optimised                           from './Optimised'
import {default as MuiTextField }          from '@material-ui/core/TextField'
import {default as MuiCheckBox }          from '@material-ui/core/Checkbox'
import MuiRadio from '@material-ui/core/Radio';
import MuiRadioGroup from '@material-ui/core/RadioGroup';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
import {default as MuiTypography} from '@material-ui/core/Typography';
import {default as MuiButton} from '@material-ui/core/Button';
import {default as MuiIconButton} from '@material-ui/core/IconButton';

export const TextField = Optimised(MuiTextField)
export const CheckBox = (props={}) => {
  const OptimisedType = Optimised(MuiCheckBox)
  return <OptimisedType {...props} type='checkbox'/>
}
export const Radio = Optimised(MuiRadio)
export const RadioGroup = Optimised(MuiRadioGroup)
export const FormControlLabel = Optimised(MuiFormControlLabel)
export const Typography = Optimised(MuiTypography)
export const Button = Optimised(MuiButton)
export const IconButton = Optimised(MuiIconButton)